// extracted by mini-css-extract-plugin
export default {"-large":"controlled-list-divider-item-module__-large--BBlkg","divider":"controlled-list-divider-item-module__divider--Dr0Hz"};